import { render } from "./cookiebanner.vue?vue&type=template&id=b4a2d812&scoped=true"
import script from "./cookiebanner.vue?vue&type=script&lang=js"
export * from "./cookiebanner.vue?vue&type=script&lang=js"

import "./cookiebanner.vue?vue&type=style&index=0&id=b4a2d812&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4a2d812"]])

export default __exports__